import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import MetricTrendChart from '@/components/common/metric-trend-chart'
import { useWeightAndHeightData } from '@/lib/weight-tracker'
import type { MedRequest } from '@/types/data'
import { format } from 'date-fns'
import { TriangleAlert } from 'lucide-react'
import { useState } from 'react'

function HeightChangedPill() {
  return (
    <div className='flex w-fit items-center gap-2 rounded-full border border-amber-400 bg-amber-50 px-4 py-2 font-poppins text-sm font-bold text-amber-600'>
      <TriangleAlert className='h-4 w-4 text-amber-500' />
      Height changed since last order
    </div>
  )
}

export default function WeightLossTracker({ medRequest }: { medRequest: MedRequest }) {
  const [openValue, setOpenValue] = useState<string | undefined>('weight-loss-tracker')
  const { latest, heightChange, chartData, isFetched } = useWeightAndHeightData(medRequest)

  return (
    <div id='weight-loss-tracker'>
      <Accordion
        type='single'
        collapsible
        value={openValue}
        className='rounded-3xl border border-custom-neutral-700 p-8'
      >
        <AccordionItem value='weight-loss-tracker' className='flex flex-col gap-8 border-0'>
          <AccordionTrigger
            className='py-0 hover:no-underline'
            onClick={e => {
              e.preventDefault()
              setOpenValue(prev => (prev ? undefined : 'weight-loss-tracker'))
            }}
          >
            <h2 className='font-poppins text-2xl font-bold leading-[133.4%] text-custom-neutral-900'>
              Weight loss tracker
            </h2>
          </AccordionTrigger>

          <AccordionContent className='flex flex-col gap-8'>
            {heightChange.changed && <HeightChangedPill />}

            {latest ? (
              <div className='flex flex-col gap-2 rounded-3xl border border-custom-neutral-200 bg-[#FAFAFB] px-8 py-6'>
                <p className='font-poppins text-lg text-custom-neutral-900'>
                  Latest Weight is : <span className='font-bold'>{latest.weightKg}kg</span>
                </p>
                <p className='font-poppins text-sm text-custom-neutral-500'>
                  Last Update: {format(latest.date, 'MMMM d, yyyy')}
                </p>
              </div>
            ) : (
              isFetched && (
                <p className='font-poppins text-sm text-custom-neutral-500'>No weight readings recorded yet.</p>
              )
            )}

            {chartData.length >= 2 && (
              <MetricTrendChart data={chartData} title='Weight progress over time' yAxisLabel='Weight (KG)' unit='kg' />
            )}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
}
